import Team from "../Team";

describe("Team model", () => {
  test("belongsTo relations", () => {
    expect(Team.belongsTo.map(relation => relation.name)).toMatchSnapshot();
  });
});
